import BlankTabIcon from '@assets/images/common/icon/blank-tab/blank-tab.svg';
import { useTenantAuth } from '@src/context/auth/useTenantAuth';
import { SHARED_URL } from '@src/routes/shared';
import UserGuideLink from '@src/ui/elements/button/UserGuideLink';
import CompanyNotificationForTenant from '@src/ui/templates/Tenant/Header/CompanyNotificationForTenant';
import TenantAccountMenu from '@src/ui/templates/Tenant/Header/TenantAccountMenu';

const CommunityMenubarForTenant = () => {
  const tenantAuth = useTenantAuth();
  return (
    <header className='sticky top-0 z-50 flex h-[61px] w-full border-b border-gray-200 bg-white pl-8 xl:pl-3 lg:hidden'>
      <div className='flex w-full items-center justify-between'>
        <nav className='size-full pr-4'>
          <ul className='flex h-full items-center gap-2'>
            <li>
              <a
                href={tenantAuth.profile?.topPageLink}
                target='_blank'
                className='relative flex h-full items-center gap-[2px] border-b-2 border-transparent px-2 transition-colors'
              >
                ポータル管理
                <img
                  src={BlankTabIcon}
                  alt=''
                  width='16'
                  height='16'
                  className='size-4'
                />
              </a>
            </li>
            <li
              className={`relative flex h-full items-center border-b-2 border-primary-500 px-2 font-semibold text-primary-500 transition-colors`}
            >
              <a href={SHARED_URL.COMMUNITY_DEFAULT_CHANNEL}>オンラインコミュニティ</a>
            </li>
          </ul>
        </nav>
        <div className='flex flex-[0_0_auto] items-center justify-end'>
          <UserGuideLink
            userType='tenant'
            device='pc'
            color='gray'
            isLogin={tenantAuth.profile?.isLogin}
          />
          <div className='flex size-[60px] items-center justify-center'>
            <CompanyNotificationForTenant />
          </div>
          <div className='h-[30px] w-px flex-[0_0_auto] bg-gray-200'></div>
          <div className='w-[280px] pl-5'>
            <TenantAccountMenu
              textColorBlack
              isCommunityHeader
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default CommunityMenubarForTenant;
